"use strict";
import s from "underscore.string";
import Auth from "../../util/auth";
import Honeybadger from "@honeybadger-io/js";
import React from "react";
import { mergeInvoiceState } from "./merge_invoice_state";
import $ from "jquery";
import _ from "underscore";
import Address from "../../components/address";
import Account from "../../api/account";
import Api from "../../api/api";
import AuditFlagEditor from "../factoring/audit_flag_editor";
import AuditFlagDisplay from "../factoring/audit_flag_display";
import Blocker from "../../components/blocker";
import classNames from "classnames";
import CloseReply from "../close_reply";
import DashboardReturnParams from "../ui/dashboard_return_params";
import { nextCompletionAction } from "./factor_invoice_completion_action";
import DebtorTypeAhead from "../debtor_typeahead";
import BrokeredCarrierTypeAhead from "../brokered_carrier_typeahead";
import DisablingButton from "../../components/disabling_button";
import DocumentBrowser from "../react_document_browser";
import DocumentsService from "../documents_service";
import BrokeredCarrierTermsService from "../brokered_carrier_terms_service";
import GeosuggestDroppableInput from "../geosuggest_dropable_input";
import ExceptionSender from "../exception_sender";
import ExtractedFields from "../factoring/extracted_fields";
import PreviousInvoiceInformation from "./previous_invoice_information";
import FactorBrokersService from "../factor_brokers_service";
import ActionBar from "../factoring/action_bar";
import FactorInvoicesService from "../factor_invoices_service";
import FactorInvoicesStore from "../../stores/factor_invoices_store";
import DataStoreService from "../data_store_service";
import FactorInvoiceUpdateService from "../factor_invoice_update_service";
import generalFormatter from "../../formatters/general";
import InvoiceAbandoner from "../invoice_abandoner";
import LoadEmailCreator from "../load_email_creator";
import loadHelper from "../loads";
import moment from "moment";
import presenceService from "../presence_service_next_gen";
import RemoveFromWaiting from "../remove_from_waiting";
import RulesAndExceptions from "./rules_and_exceptions";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
import TextDroppableInput from "../text_droppable_input";
import WaitingSpinner from "../../components/waiting_spinner";
import {
  GroupedDocumentBrowserModel,
  DocumentBatchGroupCreator
} from "../grouped_document_browser_model";
import { History } from "react-router";
import { readOnly } from "../../helpers/factor_invoice";
import { escapeRegExp } from "../../util/strings";
import { title } from "../../formatters/documents";
import { storeChangedEvent } from "../../stores/object_with_id_store";
import { createPusherInstance } from "../pusher_factory";
var FactorInvoice = React.createClass({
  mixins: [History],
  stateForGroup: function(props) {
    return this.state.groups[this.currentGroupID(props)] || this.initialStateForGroup();
  },
  setStateForGroup: function(values, props, callback) {
    var newState = this.state;
    var currentState = newState.groups[this.currentGroupID(props)] || this.initialStateForGroup();
    newState.groups[this.currentGroupID(props)] = currentState;
    _.extend(currentState, values);
    this.setState(newState, callback);
  },
  currentGroupID: function(props) {
    if ((props || this.props).groupID) {
      return (props || this.props).groupID;
    }
    return "nogroup";
  },
  initialStateForGroup: function() {
    const continueWithoutInvoiceInformation = this.props.continueWithoutInvoiceInformation;
    return {
      matchingInvoices: continueWithoutInvoiceInformation,
      viewDocuments: false,
      source_invoice_amount: null,
      debtor: null,
      load_id: null,
      source_invoice_number: null,
      lock_version: 0,
      source_invoice_date: null,
      notes: null,
      funding_notes: null,
      carrier_notes: null,
      origin: null,
      origin_lat: null,
      origin_lng: null,
      destination: null,
      destination_lat: null,
      destination_lng: null,
      extracted_fields: {},
      search_only_with_ratecon: false,
      pendingTimeout: false,
      sendingException: false,
      savingException: false,
      savingInvoice: false,
      rejecting: false,
      loadingInvoice: true,
      searchingInvoices: false,
      loadingSearchResults: false,
      abandoningInvoice: false,
      mergedFactorInvoiceIds: [],
      fetched: false,
      showingVerificationDetails: false,
      shouldShowBasicInvoiceInformation: true,
      references: ["", ""],
      carrier_amount: null,
      editedFields: {},
      sidebarOpen: Api.Account.currentSettings()["client_notes_sidebar_display"] === "expanded"
    };
  },
  getInitialState: function() {
    return {
      groups: {},
      pusher: createPusherInstance(),
      processedInvoicesCount: 0
    };
  },
  componentDidMount: function() {
    $(FactorInvoiceUpdateService).on(
      "FactorInvoiceUpdateService:invoiceUpdated",
      () => this.searchInvoices()
    );
    $(DataStoreService).on(
      "DataStoreService:factorInvoiceUpdated",
      this.invoiceStoreUpdated
    );
    $(presenceService).on(
      "presence_service:invoiceCreated",
      this.invoiceCreated
    );
    this.updateProcessedInvoicesCount({});
  },
  componentDidUpdate(prevProps, prevState) {
    if (this.props.documentBatches !== prevProps.documentBatches) {
      this.updateProcessedInvoicesCount(prevState);
    }
  },
  updateProcessedInvoicesCount(previousState) {
    const factorInvoiceIds = this.getInvoiceIdsFromBatches();
    if (factorInvoiceIds.length === 0) {
      return;
    }
    Promise.all(
      _.map(factorInvoiceIds, (id) => {
        return FactorInvoicesService.getWithId(id);
      })
    ).then((invoices) => {
      const processed = invoices.filter((invoice) => {
        return invoice.state === "processed";
      });
      if (previousState.processedInvoicesCount !== processed.length) {
        this.setState({ processedInvoicesCount: processed.length });
      }
    });
  },
  getInvoiceIdsFromBatches: function() {
    const invoiceIds = [];
    this.props.documentBatches.forEach((documentBatch) => {
      documentBatch.factor_invoices.forEach((invoice) => {
        if (invoiceIds.indexOf(invoice.id) === -1) {
          invoiceIds.push(invoice.id);
        }
      });
    });
    return invoiceIds;
  },
  invoiceCreated: function(event, data) {
    if (_.isEqual(
      _.pluck(this.props.activeDocuments, "id"),
      data.factor_invoice.document_ids
    )) {
      this.loadDataForCurrentGroup(
        this.props,
        this.state.pusher,
        data.factor_invoice,
        data.factor_invoices,
        data.verification
      );
    }
  },
  updateFromRemote: function(data, props, updateRequestedAt, updateNeedsBasicInvoiceInformation = false) {
    const currentState = this.stateForGroup(props);
    const edited = currentState.editedFields;
    const now = (/* @__PURE__ */ new Date()).getTime();
    const mergedInvoiceData = mergeInvoiceState(
      {
        factorInvoice: currentState.factorInvoice,
        lastDocumentSaveTime: this.props.lastDocumentSaveTime
      },
      data,
      updateRequestedAt
    );
    var newState = {
      factorInvoice: mergedInvoiceData.factorInvoice,
      factorBroker: data.factor_broker,
      brokeredCarrier: data.factor_invoice.brokered_carrier,
      verification: data.verification,
      verificationLastUpdatedAt: now,
      debtorVerificationStatus: data.debtor_verification_status,
      allInvoices: data.factor_invoices || currentState.factor_invoices,
      fetched: true,
      auditFlags: data.factor_invoice.data.auditFlags,
      destinationData: data.factor_invoice.data.destination,
      originData: data.factor_invoice.data.origin,
      loadingInvoice: false,
      factorClientInvoiceSubmission: data.factor_client_invoice_submission || currentState.factorClientInvoiceSubmission
    };
    if (currentState.nextSave) {
      const props2 = this.props;
      const params = currentState.nextSave.params;
      newState.auditFlags = params.audit_flags;
      const thisSaveRequestedAt = currentState.nextSave.requestedAt;
      if (updateRequestedAt != 0) {
        newState.nextSave = void 0;
        params.factor_invoice.lock_version = data.factor_invoice.lock_version;
        if (props2.documentBatchContext) {
          params.document_batch_id = props2.documentBatchContext.id;
          params.document_group_ids = _.map(
            props2.model.allGroups,
            (group) => group.id
          );
          params.incomplete_document_group_ids = _.map(
            props2.model.incompleteGroups(),
            (group) => group.id
          );
        }
        Api.FactorInvoices.create(params).then((data2) => {
          return this.updateFromRemote(data2, props2, thisSaveRequestedAt);
        });
      }
    } else {
      newState.savingInvoice = false;
      if (newState.verification && newState.verification.state == "pending") {
        setTimeout(() => {
          this.attemptToUpdateVerification();
        }, 1e3);
      }
    }
    _.extend(newState, data.factor_invoice);
    newState = _.omit(newState, (value, key) => {
      return edited[key] && edited[key] > updateRequestedAt;
    });
    const mergedState = _.extend({}, currentState, newState);
    if (!currentState.fetched || updateNeedsBasicInvoiceInformation) {
      newState.shouldShowBasicInvoiceInformation = this.needsBasicInvoiceInformation(newState);
    }
    if (this.needsBasicInvoiceInformation(mergedState)) {
      newState.shouldShowBasicInvoiceInformation = true;
    }
    if (newState.source_invoice_amount) {
      newState.source_invoice_amount = generalFormatter.cleanAmount(
        newState.source_invoice_amount
      );
    }
    if (newState.carrier_amount) {
      newState.carrier_amount = generalFormatter.cleanAmount(
        newState.carrier_amount
      );
    }
    if (newState.references) {
      newState.references = this.ensureReferencesHaveCorrectPadding(
        newState.references
      );
    }
    if (this.props.continueWithoutInvoiceInformation) {
      newState.matchingInvoices = true;
    }
    if (!this.needsBasicInvoiceInformation(newState)) {
      newState.matchingInvoices = false;
    }
    const lastUpdateAt = this.stateForGroup().factorInvoice && this.stateForGroup().factorInvoice.updated_at;
    this.setStateForGroup(newState, props || this.state.props);
    if (lastUpdateAt && lastUpdateAt != newState.factorInvoice.updated_at) {
      this.searchInvoices(data.factor_invoice.id);
    }
    return data.factor_invoice;
  },
  attemptToUpdateVerification: function() {
    if (this.stateForGroup().verification && this.stateForGroup().verification.state != "pending") {
      return;
    } else {
      const now = (/* @__PURE__ */ new Date()).getTime();
      const lastUpdatedAt = this.stateForGroup().verificationLastUpdatedAt || now;
      const oneSecond = 1e3;
      if (now - lastUpdatedAt < oneSecond) {
        return;
      } else {
        if (this.stateForGroup().factorInvoice && this.stateForGroup().factorInvoice.id) {
          Api.Verifications.verification({
            factorInvoiceId: this.stateForGroup().factorInvoice.id,
            timestamp: this.stateForGroup().verificationLastUpdatedAt || now
          }).then((data) => {
            if (data.verification && data.verification.state == "pending") {
              setTimeout(() => {
                this.attemptToUpdateVerification();
              }, 1e3);
            } else {
              if (this.stateForGroup().factorInvoice && this.stateForGroup().factorInvoice.id == data.factor_invoice_id && this.stateForGroup().verificationLastUpdatedAt == data.timestamp) {
                const newState = this.stateForGroup();
                newState.verification = data.verification;
                newState.verificationLastUpdatedAt = (/* @__PURE__ */ new Date()).getTime();
                this.setStateForGroup(newState);
              } else {
                setTimeout(() => {
                  this.attemptToUpdateVerification();
                }, 1e3);
              }
            }
          }).catch(() => {
            setTimeout(() => {
              this.attemptToUpdateVerification();
            }, 1e3);
          });
        } else {
        }
      }
    }
  },
  ensureReferencesHaveCorrectPadding: function(references) {
    this.stripPaddingFromReferences(references);
    if (_.isEmpty(references) || !s.isBlank(_.last(references))) {
      var padding = [];
      _.times(2 - references.length % 2, function() {
        padding.push("");
      });
      return references.concat(padding);
    } else {
      return references;
    }
  },
  stripPaddingFromReferences: function(references) {
    while (!_.isEmpty(references) && s.isBlank(_.last(references))) {
      references.pop();
    }
  },
  componentWillMount: function() {
    var _a, _b;
    $(FactorInvoicesStore).on(
      storeChangedEvent("FactorInvoices"),
      this.invoiceStoreUpdated
    );
    const shouldSendException = ((_b = (_a = this.props.location) == null ? void 0 : _a.query) == null ? void 0 : _b.sendException) === "true";
    if (shouldSendException) {
      const url = new URL(window.location.href);
      url.searchParams.delete("sendException");
      window.history.replaceState({}, "", url.toString());
    }
    this.props.carrier.then((carrier) => {
      if (!carrier) {
        Honeybadger.notify({
          message: "Carrier promise resolved to undefined in factor invoice",
          context: {
            factorInvoiceId: this.props.params.factorInvoiceId,
            groupID: this.props.groupID
          },
          fingerprint: "factor-invoice-carrier-undefined"
        });
      }
      this.setState({ carrier });
      return null;
    }).then(() => this.loadDataForCurrentGroup(this.props, this.state.pusher)).then(() => {
      if (shouldSendException) {
        this.setStateForGroup({ sendingException: true });
      }
    }).then(this.fetchBrokeredCarrierTerms).catch((error) => {
      Honeybadger.notify({
        message: "Error loading carrier data in factor invoice",
        context: {
          factorInvoiceId: this.props.params.factorInvoiceId,
          groupID: this.props.groupID,
          error: error.toString()
        },
        fingerprint: "factor-invoice-carrier-load-error"
      });
    });
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.groupID !== newProps.groupID || !_.isEqual(this.props.activeDocuments, newProps.activeDocuments)) {
      if (this.props.onContinueWithoutInvoiceInformation) {
        this.setStateForGroup({ matchingInvoices: false }, this.props);
        this.props.onContinueWithoutInvoiceInformation(false);
      }
      this.loadDataForCurrentGroup(newProps);
    }
    if (newProps.factorInvoiceId && this.props.factorInvoiceId !== newProps.factorInvoiceId) {
      this.grabInvoiceFromApi(newProps.factorInvoiceId, newProps, true);
    }
    if (newProps.lastDocumentSaveTime && this.props.lastDocumentSaveTime !== newProps.lastDocumentSaveTime && newProps.factorInvoiceId) {
      this.grabInvoiceFromApi(newProps.factorInvoiceId, newProps).catch(
        (error) => {
          Honeybadger.notify(error, {
            context: {
              message: "Failed to refetch invoice after document save",
              factorInvoiceId: newProps.factorInvoiceId,
              lastDocumentSaveTime: newProps.lastDocumentSaveTime
            }
          });
        }
      );
    }
  },
  factorInvoiceIdFromActiveDocuments(activeDocuments) {
    return _.chain(activeDocuments).pluck("factor_invoice_id").compact().first().value();
  },
  grabInvoiceFromApi: function(invoiceId, props, updateNeedsBasicInvoiceInformation = false) {
    return FactorInvoicesService.fetchInvoiceAndRelated(invoiceId).then(
      ({
        factorInvoice,
        factorInvoices,
        verification,
        debtorVerificationStatus,
        factorClientInvoiceSubmission
      }) => {
        this.fetchDebtorAndUpdate(
          factorInvoice.factor_broker_id,
          factorInvoice,
          factorInvoices,
          verification,
          debtorVerificationStatus,
          props,
          updateNeedsBasicInvoiceInformation,
          factorClientInvoiceSubmission
        );
        return null;
      }
    );
  },
  loadDataForCurrentGroup: function(props, pusher, factorInvoice, factorInvoices, verification, debtorVerificationStatus) {
    const invoiceId = props.factorInvoiceId || this.factorInvoiceIdFromActiveDocuments(props.activeDocuments);
    if (!invoiceId) {
      return null;
    } else {
      if (factorInvoice && factorInvoices && verification && debtorVerificationStatus) {
        this.fetchDebtorAndUpdate(
          factorInvoice.factor_broker_id,
          factorInvoice,
          factorInvoices,
          verification,
          debtorVerificationStatus,
          props
        );
      } else {
        this.grabInvoiceFromApi(invoiceId, props);
      }
      this.searchInvoices(invoiceId);
    }
    this.startListeningForGeocodeUpdates(props);
    return null;
  },
  fetchDebtorAndUpdate: function(factorBrokerId, factorInvoice, factorInvoices, verification, debtorVerificationStatus, props, updateNeedsBasicInvoiceInformation, factorClientInvoiceSubmission) {
    FactorBrokersService.getWithId(factorBrokerId).then((factorBroker) => {
      this.updateFromRemote(
        {
          factor_invoice: factorInvoice,
          factor_broker: factorBroker,
          factor_invoices: factorInvoices,
          verification,
          debtor_verification_status: debtorVerificationStatus,
          factor_client_invoice_submission: factorClientInvoiceSubmission
        },
        props,
        (/* @__PURE__ */ new Date()).getTime(),
        updateNeedsBasicInvoiceInformation
      );
    }, _.identity);
  },
  startListeningForGeocodeUpdates: function(props) {
    const email = this.findEmail(props.documentBatches);
    this.setStateForGroup({ email }, props);
    if (email) {
      FactorInvoiceUpdateService.listenForGeocodeUpdates(
        this.state.pusher,
        email.id
      );
    }
  },
  componentWillUnmount: function() {
    $(DataStoreService).off(
      "DataStoreService:factorInvoiceUpdated",
      this.invoiceStoreUpdated
    );
    $(FactorInvoicesStore).off(
      "storeChanged:FactorInvoices",
      this.invoiceStoreUpdated
    );
    $(FactorInvoiceUpdateService).off(
      "FactorInvoiceUpdateService:invoiceUpdated",
      this.saveInvoice
    );
    $(presenceService).off(
      "presence_service:invoiceCreated",
      this.invoiceCreated
    );
    FactorInvoiceUpdateService.unsubscribeFromAllChannels(this.state.pusher);
  },
  fetchBrokeredCarrierTerms() {
    if (this.carrier() && this.carrier().broker_client) {
      return BrokeredCarrierTermsService.forClient(this.carrier()).then(
        (brokeredCarrierTerms) => {
          this.setState({ brokeredCarrierTerms });
        }
      );
    }
  },
  invoiceStoreUpdated: function() {
    if (this.isMounted() && this.factorInvoice() && this.factorInvoice().id) {
      const updatedInvoice = FactorInvoicesStore.find(this.factorInvoice().id);
      if (this.invoiceUpdated(updatedInvoice) || this.invoiceExceptionEventsUpdated(updatedInvoice)) {
        var fakeData = {
          factor_invoice: updatedInvoice,
          factor_invoices: this.stateForGroup().allInvoices,
          factor_broker: this.stateForGroup().factorBroker,
          verification: this.stateForGroup().verification,
          debtor_verification_status: this.stateForGroup().debtorVerificationStatus
        };
        this.updateFromRemote(fakeData, this.props, 0);
      }
    }
  },
  invoiceUpdated: function(invoice) {
    return invoice.updated_at != this.stateForGroup().updated_at;
  },
  handleToggleSidebar: function() {
    const state = this.stateForGroup();
    this.setStateForGroup({ sidebarOpen: !state.sidebarOpen });
  },
  isSidebarFeatureEnabled: function() {
    const setting = Api.Account.currentSettings()["client_notes_sidebar_display"];
    return setting && setting !== "disabled";
  },
  invoiceExceptionEventsUpdated: function(invoice) {
    return invoice.exception_events !== this.stateForGroup().exception_events;
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { "data-component": "FactorInvoice" }, this.invoiceModuleOrDocumentBrowser());
  },
  closeDocumentBrowser: function() {
    this.setStateForGroup({ viewDocuments: false });
  },
  invoiceModuleOrDocumentBrowser: function() {
    if (this.stateForGroup().viewDocuments) {
      return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__document-browser-wrapper" }, /* @__PURE__ */ React.createElement(
        DocumentBrowser,
        {
          location: this.props.location,
          closeBrowser: this.closeDocumentBrowser,
          model: this.stateForGroup().modelForBrowser,
          documentBatch: this.stateForGroup().documentBatchForBrowser,
          collapseSingleGroup: true,
          allowsEditingPodStatus: false,
          canEditDocumentType: false
        }
      ));
    } else {
      return /* @__PURE__ */ React.createElement(Blocker, { modalView: this.possibleModalView() }, /* @__PURE__ */ React.createElement("div", null, this.actionBar(), this.possibleCreateInvoice()));
    }
  },
  actionBar() {
    const actions = [];
    const ignoreInSubmissionsWorkflow = Account.currentSettings().ignore_mode !== "SubmissionsWorkflowNoIgnore";
    if (this.canAbandonInvoice() && ignoreInSubmissionsWorkflow) {
      actions.push({
        label: "Ignore Invoice",
        action: this.startAbandoningInvoice
      });
    }
    if (!_.isEmpty(actions)) {
      return /* @__PURE__ */ React.createElement(ActionBar, { actions });
    }
  },
  auditFlagEditorOrDisplay: function() {
    var auditFlags = this.stateForGroup().auditFlags;
    if (readOnly(this.factorInvoice())) {
      return /* @__PURE__ */ React.createElement(AuditFlagDisplay, { flags: auditFlags });
    } else {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        AuditFlagEditor,
        {
          flags: auditFlags,
          overriddenFlags: this.overriddenFlags(),
          transportationClient: this.transportationClient(),
          onFlagUpdate: this.handleSaveAuditFlags
        }
      ));
    }
  },
  transportationClient() {
    const carrier = this.carrier();
    return carrier && carrier.transportation_client;
  },
  overriddenFlags() {
    return Api.Account.overriddenAuditFlags();
  },
  possibleReviewLink() {
    if (!readOnly(this.factorInvoice())) {
      return /* @__PURE__ */ React.createElement("a", { onClick: this.handleReviewFlagClick }, "review flags");
    }
  },
  handleReviewFlagClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.props.onReviewAuditFlags) {
      this.props.onReviewAuditFlags(
        this.factorInvoice(),
        this.stateForGroup().auditFlags,
        this.factorInvoice().document_ids
      );
    }
  },
  handleSaveAuditFlags(flags) {
    this.saveAuditFlags(flags);
  },
  saveAuditFlags(flags) {
    this.setStateForGroup({ auditFlags: flags }, this.props, this.saveInvoice);
  },
  markFieldDirty: function(f) {
    const existingEdited = this.stateForGroup().editedFields;
    existingEdited[f] = (/* @__PURE__ */ new Date()).getTime();
    this.setStateForGroup({ editedFields: existingEdited });
  },
  saveInvoice: function() {
    if (!this.factorInvoice()) return;
    const now = (/* @__PURE__ */ new Date()).getTime();
    var props = this.props;
    const locationData = {
      destination: this.stateForGroup().destinationData,
      origin: this.stateForGroup().originData
    };
    const params = {
      factor_invoice: this.factorInvoiceData(),
      audit_flags: this.stateForGroup().auditFlags,
      location_data: locationData
    };
    if (props.documentBatchContext) {
      params.document_group_ids = _.map(
        props.model.allGroups,
        (group) => group.id
      );
      params.incomplete_document_group_ids = _.map(
        props.model.incompleteGroups(),
        (group) => group.id
      );
    }
    if (this.stateForGroup().savingInvoice) {
      this.setStateForGroup({ nextSave: { params, requestedAt: now } });
    } else {
      this.setStateForGroup({ savingInvoice: true });
      return Api.FactorInvoices.create(params).then((data) => {
        return this.updateFromRemote(data, props, now);
      }).catch((e) => {
        const updatedState = _.tap({ savingInvoice: false }, (state) => {
          const errorFields = _.chain(
            e.responseJSON && e.responseJSON.errors || []
          ).pluck("field").compact().value();
          if (errorFields.includes("source_invoice_amount")) {
            state.source_invoice_amount = null;
          }
        });
        this.setStateForGroup(updatedState, props, this.forceUpdate);
      });
    }
  },
  saveAndReturn: function() {
    this.saveInvoice().then(() => {
      this.history.pushState(null, "/dashboard");
    });
  },
  factorInvoiceData: function() {
    var data = _.chain([
      "load_id",
      "source_invoice_amount",
      "source_invoice_number",
      "source_invoice_date",
      "notes",
      "origin",
      "origin_lat",
      "origin_lng",
      "destination",
      "destination_lat",
      "destination_lng",
      "tonu",
      "must_verify",
      "extracted_fields",
      "lock_version",
      "fuel_advance",
      "carrier_invoice_number",
      "carrier_amount",
      "payments_network_external_load_id",
      "brokered_carrier_term_id",
      "load_id_pattern_mismatch"
    ]).reduce((o, k) => {
      o[k] = this.stateForGroup()[k];
      return o;
    }, {}).value();
    data.factor_broker_id = this.stateForGroup().factorBroker ? this.stateForGroup().factorBroker.id : null;
    const brokeredCarrierId = this.stateForGroup().brokeredCarrier ? this.stateForGroup().brokeredCarrier.id : null;
    data.brokered_carrier_id = brokeredCarrierId;
    data.carrier_id = this.carrierId();
    data.id = this.factorInvoice() ? this.factorInvoice().id : null;
    data.source_invoice_amount = generalFormatter.cleanAmount(
      data.source_invoice_amount
    );
    data.carrier_amount = generalFormatter.cleanAmount(data.carrier_amount);
    data.references = (this.stateForGroup().references || ["", ""]).slice(0);
    this.stripPaddingFromReferences(data.references);
    return data;
  },
  carrierId: function() {
    var carrier = this.carrier();
    return carrier && carrier.id;
  },
  carrier: function() {
    return this.state.carrier;
  },
  setInvoiceDateToToday: function() {
    this.setStateForGroup({ source_invoice_date: this.today() }, null, () => {
      this.invoiceFieldChanged();
    });
  },
  today: function() {
    return moment(/* @__PURE__ */ new Date()).format("YYYY-MM-DD");
  },
  invoiceInput: function(field, placeholder, type) {
    return /* @__PURE__ */ React.createElement(
      ValueLinkTextDroppableInput,
      {
        type,
        disabled: readOnly(this.factorInvoice()),
        valueLink: this.myLinkState(field),
        onBlur: this.invoiceChangeComplete,
        onKeyPress: this.keyPressNotifier(field),
        placeholder
      }
    );
  },
  geosuggestInput: function(field, placeholder, type) {
    return /* @__PURE__ */ React.createElement(
      GeosuggestDroppableInput,
      {
        type,
        disabled: readOnly(this.factorInvoice()),
        valueLink: this.geosuggestValueSetter(field),
        types: ["geocode"],
        geosuggestClear: this.geosuggestClear(field),
        onBlur: this.invoiceChangeComplete,
        onKeyPress: this.keyPressNotifier(field),
        initialValue: this.stateForGroup()[field],
        nonSelect: this.nonSelect(field),
        placeholder
      }
    );
  },
  nonDroppableInvoiceInput: function(field, placeholder, type) {
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        type,
        disabled: readOnly(this.factorInvoice()),
        valueLink: this.myLinkState(field),
        onBlur: this.invoiceChangeComplete,
        onKeyPress: this.keyPressNotifier(field),
        placeholder
      }
    );
  },
  textAreaInput: function(field) {
    return /* @__PURE__ */ React.createElement(
      "textarea",
      {
        onBlur: this.invoiceChangeComplete,
        onKeyPress: this.keyPressNotifier(field),
        disabled: readOnly(this.factorInvoice()),
        valueLink: this.myLinkStateNotNull(field)
      }
    );
  },
  myLinkStateNotNull: function(field) {
    const value = this.stateForGroup()[field];
    return {
      value: value ? value : "",
      requestChange: (value2) => {
        this.markFieldDirty(field);
        var newState = this.stateForGroup();
        newState[field] = value2;
        this.setStateForGroup(newState);
        this.invoiceFieldChanged();
      }
    };
  },
  myLinkState: function(field) {
    return {
      value: this.stateForGroup()[field],
      requestChange: (value) => {
        this.markFieldDirty(field);
        var newState = this.stateForGroup();
        newState[field] = value;
        this.setStateForGroup(newState);
        this.invoiceFieldChanged();
      }
    };
  },
  geosuggestValueSetter: function(field) {
    return {
      requestChange: (suggestion) => {
        this.markFieldDirty(field);
        const locationData = this.mapLocationData(
          suggestion.description,
          suggestion.gmaps.address_components
        );
        if (field == "origin") {
          this.setStateForGroup({
            origin: suggestion.description,
            originData: locationData,
            origin_lat: suggestion.location.lat,
            origin_lng: suggestion.location.lng
          });
          this.invoiceFieldChanged();
        } else if (field == "destination") {
          this.setStateForGroup({
            destination: suggestion.description,
            destinationData: locationData,
            destination_lat: suggestion.location.lat,
            destination_lng: suggestion.location.lng
          });
          this.invoiceFieldChanged();
        }
      }
    };
  },
  mapLocationData: function(source, addressComponents) {
    const locationData = {
      city: null,
      state: null,
      postal_code: null,
      street_name: null,
      country: null,
      source
    };
    addressComponents.map((component) => {
      switch (component.types[0]) {
        case "locality":
          locationData.city = component.long_name;
          break;
        case "administrative_area_level_1":
          locationData.state = component.short_name;
          break;
        case "country":
          locationData.country = component.short_name;
          break;
        case "postal_code":
          locationData.postal_code = component.long_name;
          break;
        case "route":
          locationData.street_name = component.short_name;
          break;
      }
    });
    return locationData;
  },
  nonSelect: function(field) {
    const component = this;
    return {
      requestChange: (inputValue) => {
        component.markFieldDirty(field);
        component.setStateForGroup({ field: inputValue });
        if (field == "origin") {
          this.setStateForGroup({
            origin: inputValue,
            originData: null,
            origin_lat: null,
            origin_lng: null
          });
          component.invoiceFieldChanged();
        } else if (field == "destination") {
          this.setStateForGroup({
            destination: inputValue,
            destinationData: null,
            destination_lat: null,
            destination_lng: null
          });
          this.invoiceFieldChanged();
        }
      }
    };
  },
  geosuggestClear: function(field) {
    return {
      requestChange: () => {
        this.markFieldDirty(field);
        if (field == "origin") {
          this.setStateForGroup({
            origin: null,
            originData: null,
            origin_lat: null,
            origin_lng: null
          });
          this.invoiceFieldChanged();
        } else if (field == "destination") {
          this.setStateForGroup({
            destination: null,
            destinationData: null,
            destination_lat: null,
            destination_lng: null
          });
          this.invoiceFieldChanged();
        }
      }
    };
  },
  keyPressNotifier: function(field) {
    return this.onEnterKeyRun((event) => {
      this.invoiceFieldChanged(field, event.target.value);
      this.invoiceChangeComplete();
    });
  },
  onEnterKeyRun: function(f) {
    return function(event) {
      if (event.charCode === 13) {
        f(event);
      }
    };
  },
  invoiceChangeComplete: function() {
    this.clearTimer();
    this.saveInvoice();
  },
  invoiceFieldChanged: function() {
    this.updateTimer();
  },
  updateTimer: function() {
    this.clearTimer();
    this.setStateForGroup({
      pendingTimeout: window.setTimeout(this.saveInvoice, 200)
    });
  },
  clearTimer: function() {
    if (this.stateForGroup().pendingTimeout) {
      window.clearTimeout(this.stateForGroup().pendingTimeout);
    }
  },
  possibleSavingButtons: function() {
    if (this.isApprovable()) {
      if (!this.isSaving()) {
        return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__save-buttons-container" }, this.saveButtonList().map((element) => {
          return element;
        }), /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__completion-context" }, this.possibleCompletionContext()));
      } else {
        return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__save-buttons-container" }, this.saveButton());
      }
    }
  },
  saveButtonList() {
    const list = _.compact([
      this.possibleSaveButton(),
      this.possibleSaveAndApproveAllButton()
    ]);
    const joinedList = [];
    list.forEach((element, i) => {
      joinedList.push(element);
      if (i + 1 !== list.length) {
        joinedList.push(this.joinText());
      }
    });
    return joinedList;
  },
  possibleSaveButton() {
    if (this.isSaveable()) return /* @__PURE__ */ React.createElement("div", null, this.saveButton("Save"));
  },
  possibleSaveAndApproveAllButton() {
    if (this.showSaveAndApproveAll()) {
      const count = this.state.processedInvoicesCount + 1;
      const possiblePluralized = count === 1 ? "Invoice" : "Invoices";
      return /* @__PURE__ */ React.createElement("div", null, this.saveButton(`Save and Approve ${count} ${possiblePluralized}`, {
        approveAll: true
      }));
    }
  },
  possibleCarrierInvoiceNumberInput() {
    if (this.showCarrierInvoiceNumber()) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Carrier Invoice Number"), this.invoiceInput(
        "carrier_invoice_number",
        "Carrier Invoice Number",
        "text"
      )));
    }
  },
  saveButton: function(buttonText, options = {}) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        className: "load-detail__save-and_approve button--progress",
        disabled: this.isSaving(),
        onMouseDown: _.partial(this.saveAndMarkAsProcessed, options),
        disabledText: "Saving..."
      },
      buttonText
    ));
  },
  showSaveAndApproveAll() {
    return !Api.Account.currentSettings().verifications_workflow_enabled && this.isSaveable() && Auth._currentUser.approver && this.isApprovable() && this.onLastIncompleteGroup();
  },
  showCarrierInvoiceNumber() {
    return Api.Account.currentSettings().factor_send_carrier_invoice_number_to_cadence;
  },
  onLastIncompleteGroup() {
    return this.props && this.props.model && this.props.model.incompleteGroups().length <= 1;
  },
  joinText: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__save-buttons-join-text" }, "or");
  },
  templateVariables: function() {
    return Api.Account.current().payables_template_variables;
  },
  paymentsNetworkEnabled: function() {
    return Api.Account.currentSettings().payments_network_enabled;
  },
  verificationsEnabled: function() {
    return Api.Account.currentSettings().verifications_enabled;
  },
  verificationsWorkflowEnabled: function() {
    return Api.Account.currentSettings().verifications_workflow_enabled;
  },
  canProceed() {
    const loadId = ("" + (this.stateForGroup().load_id || "")).trim();
    const debtorId = this.stateForGroup().factor_broker_id;
    return loadId && debtorId;
  },
  hasDocument: function(requestedType) {
    return !!_.findWhere(this.props.activeDocuments, { type: requestedType });
  },
  hasCarrierInvoice() {
    return this.hasDocument("customerInvoice");
  },
  hasCustomerInvoice() {
    return this.hasDocument("invoice");
  },
  hasRatecon() {
    return this.hasDocument("rateConfirmation");
  },
  canEnterAllData() {
    return this.hasRatecon() || this.hasCarrierInvoice() || this.hasCustomerInvoice() || this.isConfirmAndSubmitPage();
  },
  saveAndMarkAsProcessed: function(options) {
    this.didStartSaving();
    const newOptions = { document_batch_ids: this.documentBatchIds() };
    newOptions.approve = options.approve;
    newOptions.approve_all = options.approveAll;
    Api.FactorInvoices.markAsProcessed(this.factorInvoice().id, newOptions).then((data) => {
      this.setStateForGroup({
        savingInvoice: false,
        factorInvoice: data.factor_invoice
      });
      this.didComplete();
    }).catch(() => {
      this.setStateForGroup({ savingInvoice: false });
    });
  },
  didStartSaving: function() {
    this.setStateForGroup({ savingInvoice: true });
  },
  isSaving: function() {
    return this.stateForGroup().savingInvoice;
  },
  saveWithErrors: function() {
    this.setStateForGroup({ savingException: true });
    Api.FactorInvoices.markAsException(
      this.factorInvoice().id,
      this.props.emailId
    ).then((data) => {
      this.setStateForGroup({
        factorInvoice: data.factor_invoice,
        savingException: false
      });
      this.didComplete();
    });
  },
  savingButton: function() {
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.stateForGroup().savingException,
        className: "button--caution",
        onClick: this.saveWithErrors,
        disabledText: "Saving..."
      },
      "Save as Incomplete"
    );
  },
  didComplete: function() {
    this.setStateForGroup({ sendingException: false });
    const action = nextCompletionAction({
      hasNext: Boolean(this.props.location.query["next"]),
      hasGroupCallback: Boolean(this.props.didCompleteGroup)
    });
    switch (action) {
      case "pushNext":
        this.history.pushState(
          null,
          this.props.location.query["next"],
          DashboardReturnParams(this.props.location)
        );
        break;
      case "delegateToGroup":
        this.props.didCompleteGroup();
        break;
      case "toDashboard":
        ToDashboardWithFilters(
          this.props.location,
          this.history,
          this.embedReturnUrl()
        );
        break;
    }
  },
  // When embedded in the Elm workflow page, this.props.location comes from
  // $hubtranHistory, which Elm's pushUrl port never updates — so it still
  // describes the dashboard we came from and has no onDone. The host passes the
  // real return URL down instead. Null when absent, which leaves
  // ToDashboardWithFilters' own location.query.onDone fallback in place for the
  // standalone route.
  embedReturnUrl: function() {
    return this.props.onDone || null;
  },
  saveAndSendException: function() {
    this.setStateForGroup({ savingException: true });
    this.cancelMatching();
    Api.FactorInvoices.markAsException(
      this.factorInvoice().id,
      this.props.emailId
    ).then(
      (data) => {
        this.setStateForGroup({
          factorInvoice: data.factor_invoice,
          sendingException: true,
          savingException: false
        });
      },
      () => {
        this.setStateForGroup({ savingException: false });
      }
    );
  },
  isApprovable: function() {
    return this.factorInvoice() && loadHelper.isApprovable(this.factorInvoice());
  },
  isSaveable: function() {
    return !this.stateForGroup().sendingException && !readOnly(this.factorInvoice()) && !this.shouldShowBasicInvoiceInformation();
  },
  possibleSaveWithErrorsButton: function() {
    if (this.isSaveable() && !this.isApprovable()) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column" }, this.savingButton()), /* @__PURE__ */ React.createElement("div", { className: "small-3 column" }, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabled: this.stateForGroup().savingException,
          className: "factor-invoice__button-cancel button--cancel",
          onClick: this.saveAndSendException,
          disabledText: "Saving..."
        },
        "Save and Send"
      )), /* @__PURE__ */ React.createElement("div", { className: "small-4 column" }, /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__completion-context" }, this.completionContext())));
    }
  },
  possibleExceptionSender: function(invoice) {
    var _a;
    if (this.stateForGroup().sendingException && invoice.active_exceptioned_item) {
      const exceptionedItemId = invoice.active_exceptioned_item.id;
      const settings = Api.Account.currentSettings() || {};
      const load = null;
      const defaultEmail = new LoadEmailCreator(
        load,
        this.factorInvoice(),
        Auth._currentUser,
        settings.custom_exception_email_subject_template,
        settings.custom_exception_email_body_template,
        this.templateVariables(),
        this.carrier()
      ).initialEmail();
      const fromReply = this.props.location.pathname.match(/factor_invoices/) && this.props.location.query.fromReply && this.props.location.query.emailId;
      const selectedGroup = this.props.model.selectedGroup;
      let documents = selectedGroup.documents;
      if (selectedGroup.relatedDocuments) {
        documents = documents.concat(selectedGroup.relatedDocuments);
      }
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        ExceptionSender,
        {
          documents,
          onComplete: this.didComplete,
          defaultEmail,
          parent: this.stateForGroup().email,
          parentId: this.props.location.query.emailId,
          markParentComplete: Boolean(fromReply),
          contacts: ((_a = this.carrier()) == null ? void 0 : _a.contacts) || [],
          canCancel: true,
          cancel: this.cancelExceptionSending,
          exceptionedItemId,
          carrierInvoice: this.factorInvoice(),
          carrier: this.carrier(),
          multipleExceptionMessagesEnabled: settings.multiple_custom_exception_templates,
          customEmailTemplates: settings.custom_exception_email_templates,
          templateVariables: this.templateVariables()
        }
      ));
    }
  },
  cancelExceptionSending: function() {
    this.setStateForGroup({ sendingException: false });
  },
  factorInvoice: function() {
    return this.stateForGroup().factorInvoice;
  },
  possibleCompletionContext: function() {
    if (this.isSaveable()) {
      return this.completionContext();
    }
  },
  completionContext: function() {
    if (this.props.hasMore) {
      return "and continue to the next Group";
    } else {
      return "and return to the Dashboard";
    }
  },
  documentBatchIds: function() {
    return _.pluck(this.props.documentBatches, "id");
  },
  findEmail: function(documentBatches) {
    var emailID = this.props.location.query["emailMessageId"];
    if (emailID) {
      return _.findWhere(_.pluck(documentBatches, "email_message"), {
        id: parseInt(emailID)
      });
    }
    return _.first(_.compact(_.pluck(documentBatches, "email_message")));
  },
  showSearchInvoices: function() {
    this.setStateForGroup({
      searchingInvoices: true,
      selectedFactorInvoiceId: null
    });
  },
  isSearchingInvoices: function() {
    return !!this.stateForGroup().searchingInvoices;
  },
  createInvoiceHeader: function() {
    if (this.isMatchingInvoices()) {
      return /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Match Existing or Save As Incomplete");
    } else if (this.currentGroupNeedsBasicInvoiceInformation()) {
      return /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Find or Create Invoice");
    } else {
      return /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Extract and Verify Information", /* @__PURE__ */ React.createElement("span", { className: "right factor-invoice__header-action" }, this.possibleMatchesButton()));
    }
  },
  possibleMatchesButton: function() {
    if (this.isMatchingInvoicesOnExtract()) {
      return /* @__PURE__ */ React.createElement("a", { onClick: this.stopShowingMatchesOnExtract }, "Hide Possible Matches");
    } else {
      return /* @__PURE__ */ React.createElement("a", { onClick: this.showMatchesOnExtract }, "Show Possible Matches");
    }
  },
  debtorSelected: function(factorBroker) {
    this.markFieldDirty("factorBroker");
    this.setStateForGroup({ factorBroker }, null, () => {
      this.saveInvoice();
    });
  },
  debtorVerificationStatusComponent: function(debtorVerificationStatus) {
    if (!debtorVerificationStatus) {
      return null;
    }
    let notificationClassName = "";
    let iconSvg = null;
    switch (debtorVerificationStatus.status) {
      case "error":
        notificationClassName = "v3__notification v3__notification--inline v3__notification--error";
        iconSvg = /* @__PURE__ */ React.createElement(
          "svg",
          {
            className: "v3__icon",
            height: "16px",
            width: "16px",
            viewBox: "0 0 16 16",
            "aria-hidden": "true"
          },
          /* @__PURE__ */ React.createElement("g", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, /* @__PURE__ */ React.createElement(
            "path",
            {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM10.7301 4.4169C10.9564 4.4169 11.1734 4.50678 11.3334 4.66677C11.4136 4.74612 11.4773 4.8406 11.5208 4.94474C11.5642 5.04887 11.5866 5.16059 11.5866 5.27343C11.5866 5.38627 11.5642 5.498 11.5208 5.60213C11.4773 5.70626 11.4136 5.80074 11.3334 5.8801L9.20673 8.0001L11.3334 10.1268C11.4934 10.2868 11.5833 10.5038 11.5833 10.7301C11.5833 10.9564 11.4934 11.1734 11.3334 11.3334C11.1706 11.4907 10.9531 11.5785 10.7267 11.5785C10.5004 11.5785 10.2829 11.4907 10.1201 11.3334L8.00006 9.2001L5.88673 11.3334C5.72495 11.4952 5.50553 11.5861 5.27673 11.5861C5.04794 11.5861 4.82851 11.4952 4.66673 11.3334C4.50495 11.1717 4.41406 10.9522 4.41406 10.7234C4.41406 10.6101 4.43638 10.498 4.47973 10.3933C4.52308 10.2886 4.58663 10.1935 4.66673 10.1134L6.80007 8.0001L4.66673 5.8801C4.50794 5.71809 4.41899 5.50029 4.41899 5.27343C4.41899 5.04658 4.50794 4.82877 4.66673 4.66677C4.7462 4.58553 4.84109 4.52099 4.94584 4.47692C5.05059 4.43286 5.16309 4.41016 5.27673 4.41016C5.39037 4.41016 5.50287 4.43286 5.60762 4.47692C5.71237 4.52099 5.80726 4.58553 5.88673 4.66677L8.00006 6.79343L10.1267 4.66677C10.2868 4.50678 10.5038 4.4169 10.7301 4.4169Z",
              fill: "#FF6347"
            }
          ))
        );
        break;
      case "warning":
        notificationClassName = "v3__notification v3__notification--inline v3__notification--warning";
        iconSvg = /* @__PURE__ */ React.createElement(
          "svg",
          {
            className: "v3__icon",
            height: "16px",
            width: "16px",
            viewBox: "0 0 16 16",
            "aria-hidden": "true"
          },
          /* @__PURE__ */ React.createElement("g", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M15.8471 13.9617L9.18279 0.744345C9.06983 0.519844 8.90023 0.331839 8.69233 0.20065C8.48443 0.0694619 8.24614 7.879e-05 8.0032 0C7.76027 7.879e-05 7.52197 0.0694619 7.31407 0.20065C7.10617 0.331839 6.93658 0.519844 6.82361 0.744345L0.15927 13.9617C0.0483055 14.1768 -0.00641988 14.4187 0.000599508 14.6629C0.00761889 14.9072 0.0761354 15.1452 0.199256 15.353C0.320703 15.5532 0.48913 15.7177 0.688569 15.8309C0.888007 15.9442 1.11184 16.0023 1.33886 15.9999H14.6675C14.897 15.9999 15.1225 15.938 15.3223 15.8203C15.5221 15.7026 15.6894 15.533 15.808 15.328C15.9266 15.1231 15.9925 14.8896 15.9994 14.6502C16.0063 14.4109 15.9538 14.1737 15.8471 13.9617ZM7.33677 5.56519C7.33677 5.38069 7.40698 5.20375 7.53196 5.07329C7.65694 4.94284 7.82645 4.86954 8.0032 4.86954C8.17995 4.86954 8.34946 4.94284 8.47444 5.07329C8.59942 5.20375 8.66964 5.38069 8.66964 5.56519V9.73909C8.66964 9.92358 8.59942 10.1005 8.47444 10.231C8.34946 10.3614 8.17995 10.4347 8.0032 10.4347C7.82645 10.4347 7.65694 10.3614 7.53196 10.231C7.40698 10.1005 7.33677 9.92358 7.33677 9.73909V5.56519ZM8.03652 13.5652C7.77404 13.5636 7.52225 13.4564 7.33356 13.2659C7.14488 13.0754 7.03383 12.8163 7.02354 12.5426C7.01909 12.405 7.04108 12.268 7.08823 12.1395C7.13539 12.011 7.20673 11.8937 7.29806 11.7944C7.38939 11.6952 7.49884 11.6161 7.61996 11.5618C7.74107 11.5075 7.87139 11.4791 8.0032 11.4782C8.26569 11.4798 8.51748 11.587 8.70616 11.7775C8.89485 11.9679 9.00589 12.227 9.01618 12.5008C9.02064 12.6383 8.99864 12.7754 8.95149 12.9039C8.90434 13.0324 8.83299 13.1497 8.74166 13.2489C8.65034 13.3481 8.54088 13.4273 8.41977 13.4816C8.29866 13.5359 8.16834 13.5643 8.03652 13.5652Z",
              fill: "#FFC229"
            }
          ))
        );
        break;
      case "success":
        notificationClassName = "v3__notification v3__notification--inline v3__notification--success";
        iconSvg = /* @__PURE__ */ React.createElement(
          "svg",
          {
            className: "v3__icon",
            height: "16px",
            width: "16px",
            viewBox: "0 0 16 16",
            "aria-hidden": "true"
          },
          /* @__PURE__ */ React.createElement("g", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM12.62 5.46667L8.05334 11.66C8.0002 11.7324 7.93297 11.7933 7.8557 11.8391C7.77843 11.8849 7.6927 11.9146 7.60366 11.9265C7.51462 11.9383 7.42411 11.932 7.33756 11.908C7.25101 11.884 7.17021 11.8427 7.1 11.7867L3.84 9.18C3.77152 9.12498 3.71458 9.05698 3.67247 8.97989C3.63035 8.90279 3.60389 8.81814 3.59459 8.73079C3.5853 8.64344 3.59336 8.55511 3.61832 8.47088C3.64327 8.38666 3.68463 8.30819 3.74 8.24C3.85078 8.10557 4.00977 8.01984 4.18296 8.00115C4.35614 7.98247 4.52976 8.0323 4.66667 8.14L7.38667 10.3133L11.5467 4.66667C11.6516 4.5261 11.8078 4.43257 11.9813 4.40636C12.1547 4.38015 12.3315 4.42338 12.4733 4.52667C12.5453 4.57824 12.6064 4.64364 12.6528 4.71906C12.6993 4.79447 12.7302 4.87839 12.7439 4.9659C12.7575 5.05341 12.7536 5.14277 12.7323 5.22875C12.7111 5.31473 12.6729 5.39561 12.62 5.46667Z",
              fill: "#14994C"
            }
          ))
        );
        break;
      case "info":
        notificationClassName = "v3__notification v3__notification--inline v3__notification--info";
        iconSvg = /* @__PURE__ */ React.createElement(
          "svg",
          {
            className: "v3__icon",
            height: "16px",
            width: "16px",
            viewBox: "0 0 16 16",
            "aria-hidden": "true"
          },
          /* @__PURE__ */ React.createElement("g", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0V0ZM8.16667 3.33333C8.36445 3.33333 8.55779 3.39198 8.72224 3.50186C8.88669 3.61174 9.01486 3.76792 9.09055 3.95065C9.16624 4.13338 9.18604 4.33444 9.14746 4.52842C9.10887 4.7224 9.01363 4.90059 8.87378 5.04044C8.73392 5.18029 8.55574 5.27553 8.36176 5.31412C8.16778 5.3527 7.96671 5.3329 7.78399 5.25721C7.60126 5.18153 7.44508 5.05335 7.3352 4.8889C7.22532 4.72445 7.16667 4.53111 7.16667 4.33333C7.16667 4.06812 7.27203 3.81376 7.45956 3.62623C7.6471 3.43869 7.90145 3.33333 8.16667 3.33333ZM9.66667 12.3333H7C6.82319 12.3333 6.65362 12.2631 6.5286 12.1381C6.40358 12.013 6.33334 11.8435 6.33334 11.6667C6.33334 11.4899 6.40358 11.3203 6.5286 11.1953C6.65362 11.0702 6.82319 11 7 11H7.5C7.54421 11 7.5866 10.9824 7.61786 10.9512C7.64911 10.9199 7.66667 10.8775 7.66667 10.8333V7.83333C7.66667 7.78913 7.64911 7.74674 7.61786 7.71548C7.5866 7.68423 7.54421 7.66667 7.5 7.66667H7C6.82319 7.66667 6.65362 7.59643 6.5286 7.4714C6.40358 7.34638 6.33334 7.17681 6.33334 7C6.33334 6.82319 6.40358 6.65362 6.5286 6.5286C6.65362 6.40357 6.82319 6.33333 7 6.33333H7.66667C8.02029 6.33333 8.35943 6.47381 8.60948 6.72386C8.85953 6.97391 9 7.31304 9 7.66667V10.8333C9 10.8775 9.01756 10.9199 9.04882 10.9512C9.08008 10.9824 9.12247 11 9.16667 11H9.66667C9.84348 11 10.0131 11.0702 10.1381 11.1953C10.2631 11.3203 10.3333 11.4899 10.3333 11.6667C10.3333 11.8435 10.2631 12.013 10.1381 12.1381C10.0131 12.2631 9.84348 12.3333 9.66667 12.3333Z",
              fill: "currentColor"
            }
          ))
        );
        break;
      default:
        return null;
    }
    return /* @__PURE__ */ React.createElement("div", { className: "enable_shared-ui-v3" }, /* @__PURE__ */ React.createElement("div", { className: "v3__theme" }, /* @__PURE__ */ React.createElement("div", { className: notificationClassName }, /* @__PURE__ */ React.createElement("span", { className: "v3__notification-icon" }, iconSvg), /* @__PURE__ */ React.createElement("div", { className: "v3__notification-text" }, /* @__PURE__ */ React.createElement("div", { className: "v3__notification-text-title" }, debtorVerificationStatus.title), debtorVerificationStatus.title.length + debtorVerificationStatus.description.length < 50 ? /* @__PURE__ */ React.createElement("span", { className: "v3__notification-text-message" }, debtorVerificationStatus.description) : /* @__PURE__ */ React.createElement("div", { className: "v3__notification-text-message" }, debtorVerificationStatus.description)))));
  },
  debtorDetails: function() {
    const debtor = this.stateForGroup().factorBroker;
    if (debtor) {
      return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__compact-address" }, /* @__PURE__ */ React.createElement(Address, { source: debtor.payment_address, compact: true }), this.possibleDebtorEmail(debtor), this.possibleEmailMismatch(debtor), this.possibleDebtorNoBuy(debtor), this.possibleDebtorPhoneNumber(
        "Primary",
        debtor.external_data.Phone1
      ), this.possibleDebtorPhoneNumber(
        "Secondary",
        debtor.external_data.Phone2
      ), this.possibleDebtorNotes(debtor));
    }
  },
  possibleDebtorNotes: function(debtor) {
    if (_.isEmpty(debtor == null ? void 0 : debtor.notes)) return null;
    return /* @__PURE__ */ React.createElement("div", null, "Notes:", /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__debtor-notes" }, /* @__PURE__ */ React.createElement("code", null, debtor.notes)));
  },
  possibleDebtorPhoneNumber: function(priOrSec, phoneNumber) {
    if (!_.isEmpty(phoneNumber)) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("a", { tabIndex: -1, href: "tel:" + phoneNumber }, priOrSec, ": ", phoneNumber.replaceAll(" ", "-"), " "));
    }
  },
  possibleDebtorWarning: function() {
    const debtor = this.stateForGroup().factorBroker;
    if (debtor && !_.isEmpty(debtor.warning)) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__debtor-warning" }, /* @__PURE__ */ React.createElement("i", { className: "fi-alert alert" }), /* @__PURE__ */ React.createElement("div", { className: "debtor-name" }, debtor.name), /* @__PURE__ */ React.createElement("div", { className: "debtor-warning" }, debtor.warning))));
    }
  },
  possibleDebtorEmail: function(debtor) {
    const possibleEmail = this.getDebtorEmail(debtor);
    if (possibleEmail != null) return /* @__PURE__ */ React.createElement("div", null, "Email: ", possibleEmail);
    return null;
  },
  possibleEmailMismatch: function(debtor) {
    if (!this.isRateConEmailInvalid(debtor)) return null;
    return /* @__PURE__ */ React.createElement("div", { className: "alert" }, /* @__PURE__ */ React.createElement("i", { className: "fi-x-circle" }), "\xA0Email on rate con does not match");
  },
  isPaymentsNetworkInvoice: function() {
    const externalLoadId = this.factorInvoiceData().payments_network_external_load_id;
    return externalLoadId ? this.paymentsNetworkEnabled() : false;
  },
  isRateConEmailInvalid: function(debtor) {
    const debtorEmail = this.getDebtorEmail(debtor);
    const validDomains = debtor.email_domains_to_validate || [];
    const rateConEmails = this.getRateConEmails(this.factorInvoice());
    if (rateConEmails.length === 0 || validDomains.length === 0) return false;
    return !rateConEmails.some(
      (email) => this.emailMatchesValidDomains(email, validDomains) || email === debtorEmail
    );
  },
  getDebtorEmail: function(debtor) {
    var _a, _b;
    return (_b = (_a = debtor.cadence_debtor_details.email) != null ? _a : debtor.billing_contact.email) != null ? _b : null;
  },
  getRateConEmails: function(invoice) {
    return invoice.document_ids.map((id) => DocumentsService.getDocumentById(id)).filter((document) => document.type === "rateConfirmation").map((document) => {
      var _a;
      const brokerEmail = (_a = document.broker_email_addresses) != null ? _a : [];
      return Array.isArray(brokerEmail) ? brokerEmail : [brokerEmail];
    }).reduce((acc, val) => acc.concat(val), []).filter((email) => email.includes("@"));
  },
  emailMatchesValidDomains: function(email, validDomains) {
    if (!email.includes("@")) return false;
    const emailParts = email.split("@");
    if (emailParts.length != 2) return false;
    const domain = emailParts[1].toLowerCase();
    const lowerCaseValidDomains = validDomains.map(
      (domain2) => domain2.toLowerCase()
    );
    return lowerCaseValidDomains.includes(domain);
  },
  possibleDebtorNoBuy: function(debtor) {
    if (debtor.no_buy) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("i", { className: "fi-alert alert" }), "\xA0No Buy");
    }
  },
  debtorCleared: function() {
    this.markFieldDirty("factorBroker");
    this.setStateForGroup({ factorBroker: null }, null, () => {
      this.saveInvoice();
    });
  },
  createInvoiceForm: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.stateForGroup().loadingInvoice }, this.invoiceDetails());
  },
  onlyLoadInformation: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information" }, this.loadInformationFormText(), /* @__PURE__ */ React.createElement("form", { onSubmit: this.handleContinue }, this.loadInformationFields(), this.loadInformationActions()));
  },
  loadInformationFormText: function() {
    if (!this.stateForGroup().sendingException) {
      return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__invoice-help-text" }, "Enter a Debtor and ", this.requiredReferenceTypeName(), ". If that information is missing, you can \xA0", /* @__PURE__ */ React.createElement("a", { onClick: this.startMatching }, "continue without invoice information."));
    }
  },
  handleContinue(event) {
    event.stopPropagation();
    event.preventDefault();
    this.startMatching();
    return false;
  },
  requiredReferenceType: function(defaultInvoice) {
    const factorInvoice = defaultInvoice || this.factorInvoice();
    return factorInvoice && factorInvoice.primary_reference_type || "load_id";
  },
  requiredReferenceTypeName: function() {
    if (this.requiredReferenceType() == "source_invoice_number") {
      return "Invoice Number";
    } else {
      return "Load ID";
    }
  },
  fieldWithHint: function(input, field) {
    const submission = this.stateForGroup().factorClientInvoiceSubmission;
    const hint = submission && submission[field];
    if (!hint) {
      return input;
    }
    return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__field-with-hint" }, input, /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__field-with-hint__hint" }, "Submitted Value: ", hint));
  },
  loadInformationFields: function() {
    var carrier = this.carrier();
    var silo = carrier && carrier.silo;
    return /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Debtor"), this.fieldWithHint(
      /* @__PURE__ */ React.createElement(
        DebtorTypeAhead,
        {
          onSelectDebtor: this.debtorSelected,
          autoFocus: true,
          readOnly: readOnly(this.factorInvoice()),
          onClearDebtor: this.debtorCleared,
          silo,
          factorBroker: this.stateForGroup().factorBroker
        }
      ),
      "debtor_name"
    ), this.debtorVerificationStatusComponent(
      this.stateForGroup().debtorVerificationStatus
    )), /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Debtor Details"), this.debtorDetails())), this.possibleDebtorWarning(), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Load ID"), this.fieldWithHint(
      this.invoiceInput("load_id", "Load ID", "text"),
      "load_id"
    ), /* @__PURE__ */ React.createElement("div", null, this.possibleLoadIdMismatch())), /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Invoice Number"), this.fieldWithHint(
      this.invoiceInput(
        "source_invoice_number",
        "Invoice Number",
        "text"
      ),
      "invoice_number"
    ))));
  },
  loadInformationActions: function() {
    const buttonClasses = classNames({
      "button--progress": true,
      "button--disabled": this.currentGroupNeedsBasicInvoiceInformation()
    });
    const buttonText = this.currentGroupNeedsBasicInvoiceInformation() ? "Enter Required Information" : "Continue";
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        disabled: this.currentGroupNeedsBasicInvoiceInformation() || this.stateForGroup().sendingException,
        onClick: this.doneWithBasicInvoiceInformation,
        className: buttonClasses
      },
      buttonText
    )), this.continueWithoutInformationLink());
  },
  continueWithoutInformationLink: function() {
    if (!this.stateForGroup().sendingException) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("a", { onClick: this.handleContinue, className: "button--cancel" }, "Continue without Invoice Information"));
    }
  },
  doneWithBasicInvoiceInformation: function(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.currentGroupNeedsBasicInvoiceInformation()) {
      this.setStateForGroup({ shouldShowBasicInvoiceInformation: false });
    }
  },
  needsBasicInvoiceInformation: function(groupState) {
    const refType = this.requiredReferenceType(groupState.factorInvoice);
    return !groupState.factorBroker || s.isBlank(groupState[refType]);
  },
  currentGroupNeedsBasicInvoiceInformation: function() {
    return this.needsBasicInvoiceInformation(this.stateForGroup());
  },
  locationFields: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Origin (City, State, Zip)"), this.geosuggestInput("origin", "Origin", "text")), /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Destination (City, State, Zip)"), this.geosuggestInput("destination", "Destination", "text")));
  },
  matchingButtons: function() {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "row factor-invoice__match-forward-buttons" }, /* @__PURE__ */ React.createElement("div", { className: "small-4 column" }, this.matchInvoiceButton()), /* @__PURE__ */ React.createElement("div", { className: "small-3 column" }, /* @__PURE__ */ React.createElement("button", { className: "button--cancel", onClick: this.cancelMatching }, "Enter Invoice Info"))), this.saveWithErrorsButton());
  },
  saveWithErrorsButton: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column" }, this.savingButton()), /* @__PURE__ */ React.createElement("div", { className: "small-3 column" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.stateForGroup().savingException,
        className: "factor-invoice__button-cancel button--cancel",
        onClick: this.saveAndSendException,
        disabledText: "Saving..."
      },
      "Save and Send"
    )), /* @__PURE__ */ React.createElement("div", { className: "small-4 column" }, /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__completion-context" }, this.completionContext())));
  },
  shouldShowBasicInvoiceInformation: function() {
    return this.stateForGroup().shouldShowBasicInvoiceInformation;
  },
  invoiceDetails: function() {
    if (this.isMatchingInvoices()) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information" }, this.locationFields(), this.referenceFields(), this.extractedFields(), this.matchingButtons(), this.possibleSearchResults());
    } else if (this.shouldShowBasicInvoiceInformation()) {
      return this.onlyLoadInformation();
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information" }, this.loadInformationFields(), this.amountAndFlags(), this.invoiceDate(), this.possibleBrokeredInvoiceInformation(), this.referenceFields(), this.extractedFields(), this.locationFields(), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Notes"), this.textAreaInput("notes"))), /* @__PURE__ */ React.createElement("div", { className: "row" }, this.possibleAuditFlags()), this.possibleSavingButtons(), this.possibleSaveWithErrorsButton(), this.possibleExtractMatching());
    }
  },
  amountAndFlags() {
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Amount"), this.fieldWithHint(
      /* @__PURE__ */ React.createElement("div", { className: "row collapse factor-invoice__amount-row" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: "small-9 columns" }, this.invoiceInput("source_invoice_amount", "Amount", "text"))),
      "amount"
    )), /* @__PURE__ */ React.createElement("div", { className: "small-3 column" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "fuel-advance-checkbox-input" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        id: "fuel-advance-checkbox-input",
        type: "checkbox",
        checked: this.stateForGroup().fuel_advance,
        onChange: this.fuelAdvanceClicked
      }
    ), "\xA0 Fuel Advance")), /* @__PURE__ */ React.createElement("div", { className: "small-2 column" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "tonu-checkbox-input" }, /* @__PURE__ */ React.createElement(
      "input",
      {
        id: "tonu-checkbox-input",
        type: "checkbox",
        checked: this.stateForGroup().tonu,
        onChange: this.tonuClicked
      }
    ), "\xA0 TONU")), this.verificationsWorkflowEnabled() && /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        checked: this.stateForGroup().must_verify,
        onChange: this.mustVerifyClicked
      }
    ), "\xA0 Must be verified")));
  },
  possibleBrokeredInvoiceInformation() {
    const brokerClient = this.carrier() && this.carrier().broker_client;
    if (brokerClient) {
      const brokeredCarrier = this.stateForGroup().brokeredCarrier;
      return /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Carrier"), /* @__PURE__ */ React.createElement(
        BrokeredCarrierTypeAhead,
        {
          onSelectBrokeredCarrier: this.brokeredCarrierSelected,
          readOnly: readOnly(this.factorInvoice()),
          onClearBrokeredCarrier: this.brokeredCarrierCleared,
          brokeredCarrier
        }
      )), this.brokeredCarrierDetails()), this.possibleCarrierInvoiceNumberInput(), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Carrier Amount"), /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: "small-9 columns" }, this.invoiceInput(
        "carrier_amount",
        "Carrier Amount",
        "text"
      )))), this.brokeredCarrierTermsView()));
    }
  },
  brokeredCarrierSelected(brokeredCarrier) {
    this.setStateForGroup({ brokeredCarrier }, null, () => this.saveInvoice());
  },
  brokeredCarrierCleared() {
    this.setStateForGroup(
      { brokeredCarrier: null },
      null,
      () => this.saveInvoice()
    );
  },
  brokeredCarrierDetails() {
    const brokeredCarrier = this.factorInvoice() && this.factorInvoice().brokered_carrier;
    if (brokeredCarrier) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Carrier Details"), /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__compact-address" }, /* @__PURE__ */ React.createElement(
        Address,
        {
          source: brokeredCarrier.tms_payment_address,
          compact: true
        }
      )));
    } else {
      return null;
    }
  },
  brokeredCarrierTermSelected(event) {
    const brokered_carrier_term_id = event.target.value;
    this.setStateForGroup(
      { brokered_carrier_term_id },
      null,
      () => this.saveInvoice()
    );
  },
  brokeredCarrierTermsView() {
    if (this.carrier() && this.carrier().broker_client) {
      const currentTermId = this.stateForGroup().brokered_carrier_term_id;
      if (this.state.brokeredCarrierTerms) {
        return /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Terms"), /* @__PURE__ */ React.createElement(
          "select",
          {
            onChange: this.brokeredCarrierTermSelected,
            value: currentTermId
          },
          /* @__PURE__ */ React.createElement("option", { value: "" }, "Please Select Term"),
          this.state.brokeredCarrierTerms.map((term) => /* @__PURE__ */ React.createElement("option", { value: term.id }, " ", term.name, " "))
        ));
      } else {
        return /* @__PURE__ */ React.createElement("span", null, "Loading...");
      }
    } else {
      return null;
    }
  },
  invoiceDate() {
    if (Account.current().settings.factor_use_source_invoice_date) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement("label", null, "Invoice Date"), this.fieldWithHint(
        this.nonDroppableInvoiceInput(
          "source_invoice_date",
          "Invoice Date",
          "date"
        ),
        "invoice_date"
      )), /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement(
        "a",
        {
          onClick: this.setInvoiceDateToToday,
          className: "factor-invoice__button-today",
          disabled: readOnly(this.factorInvoice())
        },
        "Today"
      )));
    }
  },
  possibleAuditFlags: function() {
    if (Account.current().settings.factor_use_audit_flags) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Audit Flags \xA0", this.possibleReviewLink()), this.auditFlagEditorOrDisplay());
    }
  },
  possibleCreateInvoice: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.possibleOtherInvoices(), this.possibleSourceSystemWarning(), this.possibleIgnoreProcessedMessage(), this.possibleReadOnlyMessage(), this.possibleCloseReplyButton(), this.possibleExceptionArea(), this.possibleSavingButtons(), this.possibleSaveWithErrorsButton(), this.possibleUnIgnoreButton(), this.possibleReturnToDashboardOrNextGroupButton(), this.possibleVerifications(), this.possiblePaymentsNetworkLoad(), this.createInvoiceHeader(), this.createInvoiceForm());
  },
  possibleVerifications() {
    if ((this.verificationsEnabled() || this.props.location.query.verificationsSneakPeek == "true") && this.stateForGroup().verification && !this.stateForGroup().verification.hide_display) {
      const verification = this.stateForGroup().verification;
      const verdict = this.verificationVerdict(verification.state);
      if (this.paymentsNetworkEnabled()) {
        return this.possibleVerificationsAlternateView(verification, verdict);
      } else {
        return /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            className: "verification__verdict-indicator verification__verdict-indicator--" + verdict.severity
          }
        ), "Broker Verification: ", verdict.label, this.possibleVerificationDetailsButton(verification)), this.possibleVerificationDetails(verification.disclosure_details));
      }
    }
  },
  // The verdict on the automated check, in the words and the colors
  // `Domain.Verification.verdict` gives the Elm screens that show the same outcome. This used to
  // hold two vocabularies of its own: a long label for the section header, and a short one for the
  // pill that put "Loading", an unverifiable load and a carrier we cannot look up behind a single
  // "Unverified". Both views describe one outcome, so both get one wording.
  verificationVerdict(state) {
    switch (state) {
      case "success":
        return { label: "All Clear", severity: "clear", glyph: "fi-check" };
      case "delivery_in_progress":
        return {
          label: "Verified, Delivery Unconfirmed",
          severity: "clear",
          glyph: "fi-check"
        };
      case "fail":
        return { label: "Alert", severity: "alert", glyph: "fi-alert" };
      case "non_participating_carrier":
        return {
          label: "Carrier Not Participating",
          severity: "unverifiable",
          glyph: "fi-prohibited"
        };
      case "unverifiable_load":
        return {
          label: "Load Not Verifiable",
          severity: "unverifiable",
          glyph: "fi-prohibited"
        };
      case "pending":
        return { label: "Checking", severity: "checking", glyph: "fi-clock" };
      default:
        return { label: "", severity: "", glyph: "" };
    }
  },
  possibleVerificationsAlternateView: function(verification, verdict) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", { className: "load-detail__section-header" }, "Debtor verifications", this.alternateVerificationShowDetailsButton(verification), /* @__PURE__ */ React.createElement("span", null, "\xA0"), this.possibleVerificationDataSourceTooltip(verification), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "load-detail__debtor-verification-detail-labels load-detail__debtor-verification-detail-labels--" + verdict.severity
      },
      /* @__PURE__ */ React.createElement("i", { className: verdict.glyph, "aria-hidden": "true" }),
      verdict.label
    )), this.alternateVerificationDetails(verification));
  },
  possibleVerificationDataSourceTooltip(verification) {
    var _a;
    const verificationType = (_a = this.stateForGroup().factorBroker) == null ? void 0 : _a.verifications_type;
    if (verificationType && (verificationType == "HubtranCustomer" || verificationType == "HubtranMultiAccountCustomer")) {
      return /* @__PURE__ */ React.createElement("a", null, /* @__PURE__ */ React.createElement("i", { className: "fi-info", title: "Data provided by the debtor's TMS." }));
    }
  },
  alternateVerificationShowDetailsButton(verification) {
    const verb = this.isShowingVerificationDetails() ? "Hide" : "Show";
    const icon = this.isShowingVerificationDetails() ? "fi-minus" : "fi-plus";
    return /* @__PURE__ */ React.createElement("span", { className: "right factor-invoice__header-action show-verifications-toggle" }, /* @__PURE__ */ React.createElement("a", { onClick: this.toggleVerificationDetails }, verb, " Details\xA0", /* @__PURE__ */ React.createElement("i", { className: icon })));
  },
  alternateVerificationDetails(verification) {
    if (this.isShowingVerificationDetails()) {
      const defaultDisplayedDetails = [
        "load_not_found_failure",
        "undelivered_failue",
        "carrier_mismatch_failure",
        "remit_to_failure",
        "amount_mismatch_failure"
      ];
      var detailContent = /* @__PURE__ */ React.createElement("div", null);
      switch (verification.state) {
        case "success":
          detailContent = defaultDisplayedDetails.map(
            (detail) => this.verificationDetailSuccessMessage(detail)
          );
          break;
        case "delivery_in_progress":
          detailContent = defaultDisplayedDetails.map(
            (detail) => detail === "undelivered_failue" ? this.verificationDetailSkippedMessage(detail) : this.verificationDetailSuccessMessage(detail)
          );
          break;
        case "fail":
          detailContent = this.displayFailedState(
            defaultDisplayedDetails,
            verification.disclosure_details,
            verification.mode
          );
          break;
        case "non_participating_carrier":
          detailContent = this.unverifiedDetailView(
            "Nonparticipating or unmatched carrier. This may be due to a missing MC# in your FMS"
          );
          break;
        case "unverifiable_load":
          detailContent = this.unverifiedDetailView("Load Not Verifiable");
          break;
        case "pending":
          detailContent = this.unverifiedDetailView("Loading");
          break;
      }
      return /* @__PURE__ */ React.createElement("ul", { className: "load-detail__debtor-verification-detail-display" }, detailContent);
    }
  },
  unverifiedDetailView(message) {
    return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("i", { className: "fi-alert load-detail__debtor-verification-detail-unverified-icon" }), message);
  },
  displayFailedState(defaultDisplayedDetails, disclosureDetails, mode) {
    if (this.disclosureKeysInclude(disclosureDetails, "load_not_found_failure")) {
      return this.verificationDetailAlternateDisplayFailureMessage(
        "load_not_found_failure",
        disclosureDetails["load_not_found_failure"]
      );
    } else {
      return defaultDisplayedDetails.concat(this.displayedOnFailureDetails(disclosureDetails)).map(
        (detail) => this.displayMaybeFailedDetail(detail, disclosureDetails, mode)
      );
    }
  },
  displayedOnFailureDetails(disclosureDetails) {
    var failedDetails = [];
    if (this.disclosureKeysInclude(disclosureDetails, "load_issue_failure")) {
      failedDetails = ["load_issue_failure"];
    } else if (this.disclosureKeysInclude(disclosureDetails, "on_demand_record_failure")) {
      failedDetails = ["on_demand_record_failure"];
    }
    if (this.disclosureKeysInclude(disclosureDetails, "possible_fees_failure")) {
      failedDetails = failedDetails.concat("possible_fees_failure");
    }
    return failedDetails;
  },
  displayMaybeFailedDetail(detailType, disclosureDetails, mode) {
    if (this.disclosureKeysInclude(disclosureDetails, detailType)) {
      return this.verificationDetailAlternateDisplayFailureMessage(
        detailType,
        disclosureDetails[detailType]
      );
    } else if (mode !== "restricted") {
      return this.verificationDetailSuccessMessage(detailType);
    }
  },
  verificationDetailAlternateDisplayFailureMessage(type, details) {
    return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("icon", { className: "fi-x load-detail__debtor-verification-detail-icon fail" }), "\xA0", this.verificationFailureText(type, details));
  },
  verificationDetailSkippedMessage(type) {
    var message = "";
    switch (type) {
      case "undelivered_failue":
        message = "Load delivery unconfirmed";
        break;
    }
    return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("icon", { className: "fi-minus load-detail__debtor-verification-detail-icon skipped" }), "\xA0", message);
  },
  verificationDetailSuccessMessage(type) {
    var message = "";
    const loadId = this.factorInvoice().load_id;
    switch (type) {
      case "load_not_found_failure":
        message = loadId ? "Load #" + loadId + " found" : "Load found";
        break;
      case "undelivered_failue":
        message = "Load delivered";
        break;
      case "carrier_mismatch_failure":
        message = Account.carrierTerm() + " matches";
        break;
      case "load_issue_failure":
        message = "Load has no issues";
        break;
      case "possible_fees_failure":
        message = "Load has no fees";
        break;
      case "remit_to_failure":
        message = "Remit-to address matches";
        break;
      case "amount_mismatch_failure":
        message = "Amount matches";
        break;
    }
    return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("icon", { className: "fi-check load-detail__debtor-verification-detail-icon success" }), "\xA0", message);
  },
  possibleVerificationDetailsButton(verification) {
    if (verification.state != "success" && verification.disclosure_details) {
      const verb = this.isShowingVerificationDetails() ? "Hide" : "Show";
      return /* @__PURE__ */ React.createElement("span", { className: "right factor-invoice__header-action" }, /* @__PURE__ */ React.createElement("a", { onClick: this.toggleVerificationDetails }, verb, " Details"));
    }
  },
  possibleVerificationDetails(disclosure) {
    if (this.isShowingVerificationDetails() && disclosure) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__document-information" }, /* @__PURE__ */ React.createElement("div", { className: "column" }, this.disclosureKeys(disclosure).map(
        (type) => this.verificationDetailFailureMessage(type, disclosure[type])
      )));
    }
  },
  // The same failures the Payments Network view lists, without the passes beside them.
  verificationDetailFailureMessage(type, details) {
    return /* @__PURE__ */ React.createElement("div", null, this.verificationFailureText(type, details));
  },
  // Each failure names its subject first and is the plain negation of the pass it replaces, matching
  // `Domain.Verification.viewDetailMessage` — a verifier works a batch in Elm and then opens one of
  // its invoices here, and the two lists are read against each other. There were three copies of
  // these strings in this file, which is how "Not delivered" came to sit opposite "Load delivered".
  verificationFailureText(type, details) {
    switch (type) {
      case "load_not_found_failure":
        return "Load not found";
      case "undelivered_failue":
        return "Load not delivered";
      case "carrier_mismatch_failure":
        return Account.carrierTerm() + " does not match";
      case "load_issue_failure":
      case "on_demand_record_failure":
        return "Load has an issue";
      case "possible_fees_failure":
        return "Load may have fees";
      case "remit_to_failure":
        return "Remit-to address does not match";
      case "amount_mismatch_failure":
        return details.broker_amount ? "Amount does not match the broker's $" + generalFormatter.cleanAmount(details.broker_amount) : "Amount does not match";
    }
  },
  disclosureKeysInclude(disclosure, keyToCheck) {
    return this.disclosureKeys(disclosure).includes(keyToCheck);
  },
  disclosureKeys(disclosure) {
    const keys = Object.keys(disclosure);
    if (keys.includes("load_issue_failure") && keys.includes("amount_mismatch_failure")) {
      return _.without(keys, "amount_mismatch_failure");
    } else {
      return keys;
    }
  },
  possiblePaymentsNetworkLoad() {
    if (this.paymentsNetworkEnabled() && this.factorInvoiceData().payments_network_external_load_id) {
      return /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "TPay Network Load Id:", " ", this.factorInvoiceData().payments_network_external_load_id));
    }
  },
  possibleCloseReplyButton() {
    if (this.approvedInvoiceReplyEmail()) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        CloseReply,
        {
          emailId: this.props.location.query.emailId,
          onComplete: this.didComplete
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "load-detail__completion-context" }, "and return to the Dashboard"));
    }
  },
  approvedInvoiceReplyEmail() {
    if (!this.approvedFactorInvoice()) {
      return null;
    }
    return _.find(
      this.factorInvoice().email_messages,
      (email) => !email.completed_at && email.message_type === "reply" && email.id == this.props.location.query.emailId
    );
  },
  approvedFactorInvoice() {
    const approvedStates = ["approved", "verified", "purchased"];
    const factorInvoice = this.factorInvoice();
    return factorInvoice && _.contains(approvedStates, factorInvoice.state);
  },
  abandonedFactorInvoice() {
    return this.factorInvoice() && this.factorInvoice().state === "abandoned";
  },
  reject() {
    this.setStateForGroup({ rejecting: true });
    FactorInvoicesService.rejectInvoice(this.factorInvoice().id).then((rejectedInvoice) => {
      const factorInvoices = _.chain(this.stateForGroup().allInvoices).reject((inv) => inv.id == rejectedInvoice.id).concat(rejectedInvoice).value();
      this.updateFromRemote(
        {
          factor_invoice: rejectedInvoice,
          factor_invoices: factorInvoices,
          factor_broker: this.stateForGroup().factorBroker
        },
        void 0,
        0
      );
    }).then(() => this.setStateForGroup({ rejecting: false }));
  },
  removeComplete() {
    ToDashboardWithFilters(
      this.props.location,
      this.history,
      this.embedReturnUrl()
    );
  },
  possibleRejectLink() {
    if (this.stateForGroup().rejecting) {
      return /* @__PURE__ */ React.createElement("div", null, "Rejecting...");
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__invoice-help-text" }, "This invoice has been marked processed.\xA0", /* @__PURE__ */ React.createElement("a", { onClick: this.reject }, "Reject it"), " if you need to make changes.");
    }
  },
  possibleIgnoreProcessedMessage() {
    if (this.isProcessedInWaiting()) {
      return /* @__PURE__ */ React.createElement(
        RemoveFromWaiting,
        {
          itemId: this.factorInvoice().active_exceptioned_item.id,
          onComplete: this.removeComplete
        }
      );
    }
  },
  possibleReadOnlyMessage() {
    if (this.isHubtranInvoice() && !this.stateForGroup().loadingInvoice) {
      if (readOnly(this.factorInvoice())) {
        if (this.canReject()) {
          return this.possibleRejectLink();
        } else {
          let message = "This invoice has been marked approved and cannot be changed.  Contact support if you need to make changes.";
          if (this.factorInvoice().state == "abandoned") {
            message = "This invoice has been ignored.  Un-Ignore it to make changes";
          } else if (this.factorInvoice().source_system != "hubtran") {
            message = "This invoice has been imported from the TMS, and cannot be edited";
          }
          return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__invoice-help-text" }, message);
        }
      }
    }
  },
  possibleOtherInvoices: function() {
    if (this.shouldShowBasicInvoiceInformation()) return;
    var invoices = this.stateForGroup().allInvoices;
    if (!_.isEmpty(invoices) && invoices.length > 1) {
      return /* @__PURE__ */ React.createElement(
        PreviousInvoiceInformation,
        {
          factorInvoices: invoices,
          currentInvoice: this.factorInvoice(),
          location: this.props.location
        }
      );
    }
  },
  possibleUnIgnoreButton: function() {
    var isAbandoned = loadHelper.isAbandoned(this.factorInvoice());
    if (isAbandoned) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabled: this.state.isUnIgnoring,
          className: "button--progress",
          onClick: this.revive,
          disabledText: "Un-Ignoring..."
        },
        "Un-Ignore This Invoice"
      );
    }
  },
  possibleReturnToDashboardOrNextGroupButton: function() {
    var isAbandoned = loadHelper.isAbandoned(this.factorInvoice());
    if (isAbandoned) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabled: this.state.isUnIgnoring,
          className: "button--progress load-detail__return-to-dashboard-button",
          onClick: this.didComplete,
          disabledText: "Un-Ignoring..."
        },
        this.props.hasMore ? "Go To Next Group" : "Return To Dashboard"
      );
    }
  },
  revive: function() {
    this.setState({ isUnIgnoring: true });
    Api.FactorInvoices.revive(this.factorInvoice().id).then(
      () => this.setState({ isUnIgnoring: false })
    );
  },
  possibleExceptionArea: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.possibleExceptionSender(this.factorInvoice()), this.possibleRulesAndExceptions(this.factorInvoice()));
  },
  possibleRulesAndExceptions: function(invoice) {
    if (!this.shouldShowBasicInvoiceInformation()) {
      return /* @__PURE__ */ React.createElement(
        RulesAndExceptions,
        {
          readOnly: readOnly(this.factorInvoice()),
          factorInvoice: invoice,
          exceptionCreator: this.createException,
          exceptionResolver: this.resolveException,
          exceptionEvents: this.exceptionEvents()
        }
      );
    }
  },
  exceptionEvents: function() {
    if (this.factorInvoice()) {
      return this.factorInvoice().exception_events;
    } else {
      return [];
    }
  },
  createException: function(message) {
    return Api.ExceptionEvents.create(
      this.factorInvoice().id,
      "factor",
      message
    );
  },
  resolveException: function(message, exception) {
    return Api.ExceptionEvents.resolve(
      this.factorInvoice().id,
      "factor",
      message,
      exception
    );
  },
  isMatchingInvoices: function() {
    return this.stateForGroup().matchingInvoices;
  },
  showMatchesOnExtract: function() {
    return this.setStateForGroup({ matchingInvoicesOnExtract: true });
  },
  stopShowingMatchesOnExtract: function() {
    return this.setStateForGroup({ matchingInvoicesOnExtract: false });
  },
  isMatchingInvoicesOnExtract: function() {
    return this.stateForGroup().matchingInvoicesOnExtract;
  },
  startMatching: function() {
    if (this.props.onContinueWithoutInvoiceInformation) {
      this.props.onContinueWithoutInvoiceInformation(true);
    }
    return this.setStateForGroup({ matchingInvoices: true });
  },
  cancelMatching: function() {
    if (this.props.onContinueWithoutInvoiceInformation) {
      this.props.onContinueWithoutInvoiceInformation(false);
    }
    return this.setStateForGroup({ matchingInvoices: false });
  },
  extractMatchingButtons: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, this.matchInvoiceButton()), /* @__PURE__ */ React.createElement("div", { className: "small-5 column" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--cancel",
        onClick: this.stopShowingMatchesOnExtract
      },
      "Hide Possible Matches"
    )));
  },
  isShowingVerificationDetails: function() {
    return this.stateForGroup().showingVerificationDetails;
  },
  toggleVerificationDetails: function() {
    const current = this.isShowingVerificationDetails();
    this.setStateForGroup({ showingVerificationDetails: !current });
  },
  possibleExtractMatching: function() {
    if (this.isMatchingInvoicesOnExtract()) {
      return /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, this.extractMatchingButtons(), this.possibleSearchResults());
    }
  },
  possibleSearchResults: function() {
    if (this.stateForGroup().searchResults) {
      if (_.isEmpty(this.stateForGroup().searchResults)) {
        return this.noResultsFound();
      } else {
        return this.searchResults();
      }
    }
  },
  searchSectionHeader: function() {
    return /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header" }, "Possible Matches");
  },
  noResultsFound: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, this.searchSectionHeader(), /* @__PURE__ */ React.createElement("div", { className: "row" }, "No invoices match your criteria."));
  },
  searchResults: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__search-container" }, this.searchSectionHeader(), this.searchResultsHeader(), this.mapSearchResults(this.stateForGroup().searchResults));
  },
  searchResultsHeader: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "row factor-invoice__search-headers-row" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 column" }, "\xA0"), /* @__PURE__ */ React.createElement("div", { className: "small-3 column factor-invoice__search-header" }, "SENDER INFORMATION"), /* @__PURE__ */ React.createElement("div", { className: "small-3 column factor-invoice__search-header" }, "INVOICE INFORMATION"), /* @__PURE__ */ React.createElement("div", { className: "small-3 column factor-invoice__search-header" }, "DOCUMENTS"));
  },
  openDocumentBrowser: function(documentBatchesIds, invoice) {
    DocumentsService.getDocumentBatches(documentBatchesIds).then(
      (documentBatches) => {
        var invoiceId = invoice.id;
        var model = this.modelForSearch(documentBatches, invoiceId);
        this.setStateForGroup({
          modelForBrowser: model,
          viewDocuments: true,
          documentBatchForBrowser: documentBatches[0] || null
        });
      }
    );
  },
  modelForSearch(documentBatches, invoiceId) {
    return new GroupedDocumentBrowserModel(
      new DocumentBatchGroupCreator(documentBatches, function(doc) {
        return doc.factor_invoice_id === invoiceId;
      }),
      function() {
        return false;
      },
      null
    );
  },
  mapSearchResults(results) {
    return _.map(results, (result) => {
      const invoice = result.factor_invoice;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: "factor-invoice__" + invoice.id,
          className: "row factor-invoice__search-items-container"
        },
        /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-1 column factor_invoice__search-item" }, /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "radio",
            value: invoice.id,
            checked: parseInt(this.stateForGroup().selectedFactorInvoiceId) === parseInt(invoice.id),
            onChange: this.onSelectedInvoiceChanged
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "small-3 column factor_invoice__search-item" }, this.invoiceEmailSubject(invoice), /* @__PURE__ */ React.createElement("br", null), this.invoiceEmailDate(invoice)), /* @__PURE__ */ React.createElement("div", { className: "small-3 column factor_invoice__search-item" }, this.invoiceInformation(result)), /* @__PURE__ */ React.createElement("div", { className: "small-3 column factor_invoice__search-item" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "factor-invoice__documents-icon",
            onClick: _.partial(
              this.openDocumentBrowser,
              invoice.document_batch_ids,
              invoice
            )
          },
          /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__documents-count" }, this.documentTypesForInvoice(invoice).join(", "))
        )))
      );
    });
  },
  documentsCountText: function(count) {
    if (count === 0) {
      return count + " Documents.";
    } else if (count === 1) {
      return count + " Document:";
    } else {
      return count + " Documents:";
    }
  },
  invoiceInformation: function(result) {
    var factorInvoice = result.factor_invoice;
    var component = this;
    var fields = {
      "Origin:": "origin",
      "Destination:": "destination",
      "Amount: ": "source_invoice_amount",
      "Debtor: ": "debtor",
      "Reference Match:": "references",
      "Load ID:": "load_id"
    };
    var divs = _.mapObject(fields, function(val, key) {
      if (val === "load_id" && factorInvoice.load_id) {
        return /* @__PURE__ */ React.createElement("div", { key: "factor-invoice__" + factorInvoice.id + val }, /* @__PURE__ */ React.createElement("strong", null, " ", key, " "), " ", factorInvoice.load_id);
      } else if (val === "debtor" && result.debtor) {
        return /* @__PURE__ */ React.createElement("div", { key: "factor-invoice__" + factorInvoice.id + val }, /* @__PURE__ */ React.createElement("strong", null, " ", key, " "), " ", result.debtor.name);
      } else if (val === "references") {
        var references = _.without(result.matches, "origin", "destination");
        return _.map(references, _.partial(component.referenceDiv, key));
      } else {
        var shouldBeCalledOut = _.contains(result.matches, val);
        var classes = classNames({
          "factor-invoice__matching-search-field": shouldBeCalledOut
        });
        if (factorInvoice[val]) {
          const value = component.value(factorInvoice, val);
          return /* @__PURE__ */ React.createElement(
            "div",
            {
              key: "factor-invoice__" + factorInvoice.id + val,
              className: classes
            },
            " ",
            /* @__PURE__ */ React.createElement("strong", null, " ", key, " "),
            " ",
            value,
            " "
          );
        }
      }
    });
    return _.values(divs);
  },
  value: function(factorInvoice, value) {
    if (value === "source_invoice_amount") {
      return generalFormatter.currency(factorInvoice[value]);
    } else {
      return factorInvoice[value];
    }
  },
  referenceDiv: function(label, reference) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: "factor-invoice__" + reference,
        className: "factor-invoice__matching-search-field"
      },
      " ",
      /* @__PURE__ */ React.createElement("strong", null, " ", label, " "),
      " ",
      reference,
      " "
    );
  },
  invoiceEmailSubject: function(factorInvoice) {
    return factorInvoice.document_batch_email_subject || "No Subject";
  },
  invoiceEmailDate(factorInvoice) {
    const emailDate = factorInvoice.document_batch_email_date;
    if (!emailDate) return "";
    return generalFormatter.superShortDate(emailDate) + " " + generalFormatter.superShortTime(emailDate);
  },
  documentTypesForInvoice(invoice) {
    return _.chain(invoice.document_ids).map((id) => DocumentsService.getDocumentById(id)).map((document) => {
      if (_.contains(
        ["invoice", "rateConfirmation", "billOfLading"],
        document.type
      )) {
        return title(document);
      } else {
        return "Other";
      }
    }).groupBy(_.identity).pairs().map(([t, ts]) => `${t} (${ts.length})`).value();
  },
  onSelectedInvoiceChanged: function(e) {
    this.setStateForGroup({ selectedFactorInvoiceId: e.currentTarget.value });
  },
  tonuClicked: function(e) {
    this.markFieldDirty("tonu");
    this.setStateForGroup(
      { tonu: e.currentTarget.checked },
      null,
      this.saveInvoice
    );
  },
  fuelAdvanceClicked: function(e) {
    this.markFieldDirty("fuel_advance");
    this.setStateForGroup(
      { fuel_advance: e.currentTarget.checked },
      null,
      this.saveInvoice
    );
  },
  mustVerifyClicked: function(e) {
    this.markFieldDirty("must_verify");
    this.setStateForGroup(
      { must_verify: e.currentTarget.checked },
      null,
      this.saveInvoice
    );
  },
  completeInvoiceAndSearch: function() {
    this.invoiceChangeComplete();
    this.searchInvoices(this.factorInvoice() && this.factorInvoice().id);
  },
  matchInvoiceButton: function() {
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        className: "load-detail__save-and-approve button--progress",
        disabled: !this.stateForGroup().selectedFactorInvoiceId || this.stateForGroup().assigningDocuments,
        onClick: this.assignDocumentsToSelectedInvoice,
        disabledText: this.stateForGroup().assigningDocuments ? "Assigning..." : "Select Invoice to Match"
      },
      "Assign Selected Invoice's Documents to This Invoice"
    );
  },
  assignDocumentsToSelectedInvoice: function() {
    const selectedFactorInvoiceId = this.stateForGroup().selectedFactorInvoiceId;
    const mergedFactorInvoiceIds = this.stateForGroup().mergedFactorInvoiceIds;
    if (mergedFactorInvoiceIds.indexOf(selectedFactorInvoiceId) !== -1) {
      return;
    }
    this.setStateForGroup({
      assigningDocuments: true,
      mergedFactorInvoiceIds: mergedFactorInvoiceIds.concat([
        selectedFactorInvoiceId
      ])
    });
    const props = this.props;
    Api.FactorInvoices.mergeInvoices(
      this.factorInvoice().id,
      selectedFactorInvoiceId
    ).then((data) => {
      this.setStateForGroup(
        {
          assigningDocuments: false,
          searchingInvoices: false,
          matchingInvoices: false,
          continueWithoutInvoiceInformation: false
        },
        null,
        () => {
          this.updateFromRemote(data, props, (/* @__PURE__ */ new Date()).getTime());
        }
      );
    }).then(this.props.onMergeDocumentBatches).catch(() => {
      this.setStateForGroup({
        assigningDocuments: false,
        mergedFactorInvoiceIds: this.stateForGroup().mergedFactorInvoiceIds.filter(
          (id) => id !== selectedFactorInvoiceId
        )
      });
    });
  },
  searchInvoices: function(invoiceId) {
    if (this.isMounted() && this.carrierId()) {
      this.setStateForGroup({
        searchResults: null,
        selectedFactorInvoiceId: null,
        loadingSearchResults: true
      });
      Api.FactorInvoices.searchInvoices(this.buildSearchParams(invoiceId)).then(
        (results) => {
          results = _.reject(results, (result) => {
            return result.factor_invoice.id === (this.factorInvoice() && this.factorInvoice().id);
          });
          this.setStateForGroup({
            searchResults: results,
            loadingSearchResults: false
          });
        }
      );
    }
  },
  buildSearchParams: function(invoiceId) {
    const factorInvoiceId = invoiceId || this.factorInvoice() && this.factorInvoice().id;
    return {
      carrier_id: this.carrierId(),
      id: factorInvoiceId,
      distance: 25
    };
  },
  isSearching: function() {
    return this.stateForGroup().loadingSearchResults;
  },
  invoiceUrl(invoice) {
    return `/app/factor_invoices/${invoice.id}`;
  },
  isHubtranInvoice() {
    return this.factorInvoice() && this.factorInvoice().source_system === "hubtran";
  },
  canReject() {
    return this.factorInvoice() && this.factorInvoice().state == "processed";
  },
  isProcessedInWaiting() {
    return readOnly(this.factorInvoice()) && this.factorInvoice() && this.factorInvoice().active_exceptioned_item;
  },
  isConfirmAndSubmitPage: function() {
    return !!this.props.confirmAndSubmit;
  },
  referenceFields: function() {
    var asPairs = (a) => {
      var tmp = a.slice();
      var pairs = [];
      while (!_.isEmpty(tmp)) {
        pairs.push(tmp.splice(0, 2));
      }
      return pairs;
    };
    var mapReference = (value, referenceIndex) => {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "small-5 column",
          key: "reference_internal_row_" + referenceIndex
        },
        /* @__PURE__ */ React.createElement("label", null, "Reference"),
        /* @__PURE__ */ React.createElement(
          TextDroppableInput,
          {
            type: "text",
            onDrop: this.referenceChangedHandlerForIndex(referenceIndex),
            readOnly: readOnly(this.factorInvoice()),
            onChange: this.referenceChangedHandlerForIndex(referenceIndex),
            onBlur: this.invoiceChangeComplete,
            onKeyPress: this.onEnterKeyRun(this.invoiceChangeComplete),
            value
          }
        )
      );
    };
    return _.map(
      asPairs(this.stateForGroup().references || ["", ""]),
      (pair, pairIndex) => {
        return /* @__PURE__ */ React.createElement("div", { className: "row", key: "reference_field_row_" + pairIndex }, _.map(pair, (reference, pairOffset) => {
          return mapReference(reference, 2 * pairIndex + pairOffset);
        }));
      }
    );
  },
  extractedFields() {
    const invoice = this.factorInvoice();
    if (invoice) {
      return /* @__PURE__ */ React.createElement(
        ExtractedFields,
        {
          fieldsSourceObject: invoice.extracted_fields,
          sourceId: invoice.id,
          extractedFields: this.extractedFieldsFields(),
          onChange: this.extractedFieldsChanged
        }
      );
    }
  },
  extractedFieldsFields: function() {
    const settings = Api.Account.currentSettings() || {};
    if (this.stateForGroup().factorBroker) {
      const fieldsFromCustomer = this.stateForGroup().factorBroker.settings.factor_invoice_extracted_fields || [];
      const fieldsFromAccount = settings.factor_invoice_extracted_fields || [];
      return _.uniq(
        _.reject(
          fieldsFromAccount.concat(fieldsFromCustomer),
          (field) => field.hidden
        )
      );
    } else {
      return settings.factor_invoice_extracted_fields || [];
    }
  },
  extractedFieldsChanged(updatedFields) {
    this.markFieldDirty("extracted_fields");
    this.setStateForGroup({ extracted_fields: updatedFields });
    this.invoiceFieldChanged();
  },
  referenceChangedHandlerForIndex: function(i) {
    return (event, value) => {
      if (value && escapeRegExp(value).match(/reference_field_row.+reference_internal_row/)) {
        return;
      }
      this.markFieldDirty("references");
      var current_references = this.stateForGroup().references;
      var new_references = current_references ? current_references.splice(0) : ["", ""];
      new_references[i] = "" + (value || event.currentTarget.value);
      this.setStateForGroup({
        references: this.ensureReferencesHaveCorrectPadding(new_references)
      });
      this.invoiceFieldChanged();
    };
  },
  startAbandoningInvoice: function() {
    this.setState({ abandoningInvoice: true });
  },
  canAbandonInvoice: function() {
    return !this.approvedFactorInvoice() && !this.abandonedFactorInvoice();
  },
  abandonInvoice(reason) {
    return Api.FactorInvoices.abandon(this.factorInvoice().id, reason).then(this.props.factorInvoiceAbandonedCallback).then(() => {
      this.setState({ abandoningInvoice: false });
    }).catch(console.error);
  },
  possibleModalView: function() {
    if (this.state.abandoningInvoice) {
      return /* @__PURE__ */ React.createElement(
        InvoiceAbandoner,
        {
          abandon: this.abandonInvoice,
          onCancel: () => this.setState({ abandoningInvoice: false })
        }
      );
    }
  },
  possibleLoadIdMismatch: function() {
    const { verification } = this.stateForGroup();
    if (this.factorInvoiceData().load_id_pattern_mismatch && (!verification || verification.state === "unverifiable_load")) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__load-id-pattern-mismatch-warning" }, /* @__PURE__ */ React.createElement("div", { className: "fi-alert alert" }, " ", "Load ID does not match debtor load pattern"))));
    }
  },
  possibleSourceSystemWarning() {
    if (this.factorInvoice() && !this.isHubtranInvoice()) {
      return /* @__PURE__ */ React.createElement("div", { className: "factor-invoice__invoice-help-text" }, "This invoice was created externally and was not processed in TriumphPay Audit.");
    }
  }
});
export default FactorInvoice;
